<div class="pdf-page app-aul-040-26" id="aul04026">  
  <p class="font-large mb-0" style="text-align: center">
    <b>EQUIPMENT BREAKDOWN COVERAGE NOTICE </b>
  </p>  

  <p class="font-small">
    In consideration of the premium charged, it is understood and agreed that this policy is amended 
    to include coverage for “Equipment breakdown” as defined in the <b>EQUIPMENT BREAKDOWN ENHANCEMENT 
    ENDORSEMENT (AUL EQUIPMENT BREAKDOWN ENHANCEMENT ENDORSEMENT CP EB 2025)</b>, which is attached 
    to and made part of this Policy.
  </p>

  <p class="font-small">
    Equipment Breakdown coverage and related servicing is provided by FM Boiler Re (“FM”) on behalf 
    of the property insurers identified within this policy. The coverage includes the inspection servicing
    of jurisdictional boilers and pressure vessels by FM, at no additional cost to you.
  </p>

  <p class="font-small">
    FM is an accredited, authorized inspection agency in all jurisdictions in the United States and Canada.
  </p>

  <p class="font-small">
    The FM inspector is:
  </p>
  <ul class="font-small">
    <li>Trained on the ASME (American Society of Mechanical Engineers) codes governing boiler and 
        pressure vessel construction, installation and operation</li>
    <li>Certified by examination</li>
    <li>Commissioned by the National Board of Boilers and Pressure Vessels Inspectors</li>
    <li>A recipient of a certificate of competency issued by the jurisdiction</li>
  </ul>

  <p class="font-small">
   FM prides itself on the expertise of its inspectors and is pleased to provide these essential services 
   to your organization. FM’s extensive jurisdictional knowledge will assist you with compliance to local 
   regulations so you can stay focused on what matters most to you—your business. In addition, your 
   inspector will identify conditions observed on the boiler or pressure vessel that have the potential 
   to lead to a loss and offer loss prevention recommendations through a written report.
  </p>

  <p class="font-small">
    About the visit. The FM inspector will perform the following necessary services to help you comply 
    with your local jurisdictional requirements:
  </p>

   <ul class="font-small">
    <li>Conduct internal and external pressure-vessel inspections</li>
    <li>Witness the testing of safety devices</li>
    <li>Document all results</li>
    <li>Provide the inspection results to you</li>
    <li>Submit these results to the jurisdictional authority on your behalf</li>
  </ul>

  <p class="font-small">
    Once these steps are completed, your jurisdictional authority will 
    issue a certificate indicating that your equipment is compliant with applicable regulations.
  </p>

  <p class ="font-small">
    <b>More information:</b>
  </p>

  <p class="font-small">
    These inspections are provided as part of your insurance coverage eliminating the need for and payment 
    to the jurisdictional authorities to conduct these inspections. Certificate fees billed by the 
    jurisdictional authorities directly to the insured client are the responsibility of the insured client 
    to issue payment.
  </p>

  <p class="font-small">
    In the following U.S. jurisdictions, where the certificate fee is billed directly to the insurance company, FM Boiler Re pays these fees for you:
  </p>

  <p class="font-small">
    California, Hawaii, Kentucky, New Jersey, New York, South Dakota, Vermont, West Virginia, New Orleans, 
    Louisiana, New York City, New York and Omaha, Nebraska.
  </p>

   <p class="font-small">
    For more information on jurisdictional inspections, please call the FM Boiler Re toll-free hotline at 
    866 594 1257 or email us at <a class="link" href="mailto:inspections@fm.com">inspections&#64;fm.com</a>       
  </p>

</div>
